import TH_Validator from '_tradeholding/js/Classes/Validator';

let Validator = new TH_Validator();

export default Validator;